import { blue20opacity15, blue50, blue60, blue70, blue90 } from '../../../colors/blue';
import { white } from '../../../colors/gray';
import { neutral60opacity10, neutral60opacity20 } from '../../../colors/neutral';
import { red03, red04 } from '../../../colors/red';
import { rem } from '../../../utils/rem';
export var ButtonTransition = 'background-color 50ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 50ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 50ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
export var MuiButton = {
    defaultProps: { disableElevation: true, variant: 'contained' },
    styleOverrides: {
        root: {
            borderRadius: rem(3),
            height: rem(30),
            paddingBlock: 0,
            paddingInline: rem(12),
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 2px ".concat(blue60),
            },
            '&[class*=Mui-disabled]': {
                opacity: 0.4,
            },
            transition: ButtonTransition,
        },
        containedPrimary: {
            '&:hover': {
                backgroundColor: blue60,
            },
            '&:active': {
                backgroundColor: blue70,
            },
            '&[class*=Mui-disabled]': {
                backgroundColor: blue50,
                color: white,
                opacity: 0.4,
            },
        },
        containedSecondary: {
            '&:hover': {
                backgroundColor: neutral60opacity20,
            },
            '&:active': {
                backgroundColor: blue20opacity15,
            },
            '&[class*=MuiButton-icon]': {
                backgroundColor: neutral60opacity10,
                color: blue60,
                opacity: 0.4,
            },
            '&[class*=Mui-disabled]': {
                backgroundColor: neutral60opacity10,
                color: blue60,
                opacity: 0.4,
            },
        },
        containedInherit: {
            background: 'inherit',
            '&:hover': {
                background: 'rgba(103, 103, 102, 0.2)',
            },
        },
        sizeSmall: {
            display: 'flex',
            fontSize: '0.775rem',
            height: rem(26),
            paddingBlock: 0,
            paddingInline: rem(12),
            '&[class*=MuiButton-icon]': {
                width: rem(26),
                minWidth: rem(26),
            },
        },
        text: {
            backgroundColor: 'transparent',
            color: blue60,
            '&:hover': {
                backgroundColor: neutral60opacity20,
            },
            '&:active': {
                backgroundColor: blue20opacity15,
            },
            '&[class*=Mui-disabled]': {
                backgroundColor: 'transparent',
                color: blue60,
                opacity: 0.4,
            },
        },
        iconSizeSmall: {
            '& > *:first-of-type': {
                fontSize: 1,
            },
        },
        iconSizeMedium: {
            '& > *:first-of-type': {
                fontSize: 1,
            },
        },
        iconSizeLarge: {
            '& > *:first-of-type': {
                fontSize: 1,
            },
        },
    },
    customOverrides: {
        icon: {
            minWidth: rem(30),
            width: rem(30),
        },
        dangerPrimary: {
            backgroundColor: red03,
            color: white,
            '&:hover': {
                backgroundColor: red04,
            },
            '&:active': {
                backgroundColor: blue90,
            },
            '&[class*=Mui-disabled]': {
                backgroundColor: red03,
                color: white,
            },
        },
        dangerSecondary: {
            color: red04,
            '&[class*=Mui-disabled]': {
                color: red04,
            },
        },
        dangerTertiary: {
            color: red03,
            '&[class*=Mui-disabled]': {
                color: red03,
            },
        },
    },
};
